import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import Alert from '../components/Common-components/Modal/alert';

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [footerContent, setFooterContent] = useState(null);
  const [confirmButtonText, setConfirmButtonText] = useState('확인');
  const [showConfirmButton, setShowConfirmButton] = useState(true); // showConfirmButton 상태 추가
  const actionCallback = useRef(null);
  const closeCallback = useRef(null);

  // showAlert 함수를 객체 옵션 방식으로 변경하여 가독성 및 확장성 개선
  const showAlertWithOptions = (options) => {
    setTitle(options.title || '알림');
    setContent(options.content);
    setFooterContent(options.footerContent || null);
    setConfirmButtonText(options.confirmButtonText || '확인');
    setShowConfirmButton(options.showConfirmButton !== false); // false가 명시된 경우에만 false, 그 외엔 모두 true
    actionCallback.current = options.action || null;
    closeCallback.current = options.onClose || null; // 취소/닫기 콜백 지원
    setIsOpen(true);
  };

  const hideAlert = () => {
    setIsOpen(false);
    // 상태 초기화는 애니메이션 등을 고려하여 약간의 딜레이 후 처리하는 것이 좋을 수 있습니다.
    // setTimeout(() => {
    //   setTitle('');
    //   setContent('');
    //   setFooterContent(null);
    //   setConfirmButtonText('확인');
    //   setShowConfirmButton(true);
    //   actionCallback.current = null;
    // }, 200); // 예: 0.2초 후
  };

  const handleAction = () => {
    if (actionCallback.current) {
      actionCallback.current();
    }
    hideAlert();
  };

  const handleClose = () => {
    if (closeCallback.current) {
      closeCallback.current();
    }
    hideAlert();
  };

  useEffect(() => {
    const originalAlert = window.alert;
    window.alert = (arg) => {
      if (typeof arg === 'object' && arg !== null) {
        // 객체로 전달된 경우, 모든 옵션을 showAlertWithOptions 함수로 전달
        showAlertWithOptions(arg);
      } else {
        // 문자열로 전달된 경우, 기본 옵션으로 content만 설정하여 호출
        showAlertWithOptions({ content: arg });
      }
    };

    return () => {
      window.alert = originalAlert;
    };
  }, []); // 의존성 배열 비워서 마운트 시 한 번만 실행되도록 수정

  return (
    <AlertContext.Provider value={{ showAlert: showAlertWithOptions, hideAlert }}>
      {children}
      <Alert 
        isOpen={isOpen} 
        title={title} 
        content={content} 
        footerContent={footerContent} 
        onClose={handleClose} 
        onAction={handleAction} 
        confirmButtonText={confirmButtonText}
        showConfirmButton={showConfirmButton} // Alert 컴포넌트에 상태 전달
      />
    </AlertContext.Provider>
  );
};
